<template>
  <div class="addfood-overlay" @click.self="$emit('close')">
    <div class="addfood-panel">
      <button class="close-btn" @click="$emit('close')">×</button>
      <h2>Add Food</h2>

      <label>
        Food name:
        <input type="text" v-model="foodName" placeholder="e.g. Apple" />
      </label>

      <label>
        Carbs (grams):
        <input type="number" v-model.number="carbs" placeholder="e.g. 14" />
      </label>

      <label>
        Per grams:
        <input type="number" v-model.number="perGrams" />
      </label>

      <button class="add-btn" @click="addFood">Add Food</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddFood",
  data() {
    return {
      foodName: "",
      carbs: 0,
      perGrams: 100
    };
  },
  methods: {
    addFood() {
      if (!this.foodName || !this.carbs) return;

      // Normalize carbs to per 100g
      const carbsPer100 = (this.carbs / this.perGrams) * 100;

      const newFood = {
        id: Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
        name: this.foodName.trim(),
        carbs: Number(carbsPer100.toFixed(2)), // store as per 100g
        weight: 0
      };

      this.$emit("add-food", newFood);
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.addfood-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.4);
  z-index: 1000;
}

.addfood-panel {
  position: absolute;
  top: 100px;
  bottom: 100px;
  left: 20px;
  min-width: 300px;
  max-width: 400px;
  width: 90%;
  background: #222;
  color: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 5px 20px rgba(0,0,0,0.5);
  box-sizing: border-box;
  overflow-y: auto;
}

.addfood-panel label {
  display: block;
  margin-bottom: 1rem;
}

.addfood-panel input {
  width: 100%;
  padding: 6px;
  border-radius: 6px;
  border: 1px solid #555;
  background: #333;
  color: #fff;
}

.add-btn {
  background: #28a745;
  color: white;
  padding: 10px 14px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
.add-btn:hover {
  background: #218838;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
}
</style>
